// import styled, { css } from 'styled-components';
import styled, { css } from 'styled-components/macro'


import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  fonts: { brandonGrotesqueMedium },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  typography: { buttonText },
} = mixins;

export const HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;

  @media ${tabletPortraitDown} {
    display: none;
  }
`;

export const MobileHeaderContainer = styled.div`
  display: none;

  @media ${tabletPortraitDown} {
    display: block;
  }
`;

export const HeaderInnerContainer = styled.div`
  display: grid;
  grid-template-columns: 25% 50% 25%;
  grid-template-rows: 35px 80px;

  @media ${tabletPortraitDown} {

  }

  @media ${mobileDown} {
    
  }
`;

export const LogoContainer = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 3;


  @media ${tabletPortraitDown} {
    
  }

  @media ${mobileDown} {
    
  }
`;

export const LogoLink = styled.a`
  text-decoration: none;
`;

export const LogoImage = styled.img`
  padding: ${spacingsize(8)};
  width: 100%;
  max-width: 250px;
`;

export const NavigationContainer = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 2;

  @media ${tabletPortraitDown} {
    
  }
`;

const navigationItemSpacing = spacingsize(3);

export const Navigation = styled.ul`
  display: flex;
  justify-content: space-evenly;
  list-style: none;
  background: ${color(`black`)};
  padding: 0;
  margin: 0;
`;

export const SubNavigationContainer = styled.div`
  display: none;
  position: absolute;
  top: 35px;
  left: 0;
  background-color: ${color(`white`)};
  width: 50vw;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  padding: 0;
  margin: 0;
`;

export const SubNavigation = styled.ul`
  background: ${color(`white`)};
  list-style: none;
  display: flex;
  justify-content: space-evenly;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const NavigationItem = styled.li`
  position: relative;
  width: 100%;
  list-style: none;
  display: inline-block;
  padding: ${navigationItemSpacing};
  text-align: center;

  &:hover div[data-subnavigation] {
    display: block;
  }
`;

export const SubNavigationItem = styled.li`
  position: relative;
  width: 100%;
  list-style: none;
  display: inline-block;
  padding: ${navigationItemSpacing};
  text-align: center;
`;

export const navigationItemsText = css`
  ${brandonGrotesqueMedium}
  text-transform: uppercase;
  font-size: ${fontsize(6)};

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(5)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(5)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(5)};
  }
`;

export const NavigationLink = styled.a`
  ${navigationItemsText}
  text-decoration: none;
  color: ${color(`white`)};
  -webkit-transition: color 1.5s; /* For Safari 3.0 to 6.0 */
  transition: color 1.5s; /* For modern browsers */

  &:hover {
    color: ${color(`teal`)};

    ${SubNavigation} {
      display: block;
    }
  }
`;

export const SubNavigationLink = styled.a`
  ${navigationItemsText}
  text-decoration: none;
  color: ${color(`black`)};
  -webkit-transition: color 1.5s; /* For Safari 3.0 to 6.0 */
  transition: color 1.5s; /* For modern browsers */

  &:hover {
    color: ${color(`teal`)};
  }
`;

export const CtaContainer = styled.div`
  grid-column-start: 3;
  grid-column-end: 4;
  grid-row-start: 1;
  grid-row-end: 3;

  @media ${tabletPortraitDown} {
    
  }
`;

export const CtaInnerContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;
  padding: ${spacingsize(8)};
`;

const ctaButtonText = css`
  ${navigationItemsText}
  text-decoration: none;
  text-transform: uppercase;
  padding: ${spacingsize(5)};

  &:hover{
    background-color: ${color(`teal`)};
    color: ${color(`black`)};
  }
`;

export const ApplyButton = styled.a`
  ${ctaButtonText}
  background-color: ${color(`white`)};
  color: ${color(`black`)};
  border: solid 1px ${color(`black`)};
`;

export const BookATourButton = styled.a`
  ${ctaButtonText}
  background-color: ${color(`black`)};
  color: ${color(`white`)};
  border: solid 1px ${color(`black`)};
`;